function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "226.334 71.909 82.267 82.267",
    width: 82.267,
    height: 82.267,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 226.334 71.909 L 226.334 154.176 L 308.601 154.176 L 308.601 71.909 L 226.334 71.909 Z M 233.813 79.388 L 301.122 79.388 L 301.122 146.697 L 233.813 146.697 L 233.813 79.388 Z M 241.292 128 L 241.292 135.479 L 293.643 135.479 L 293.643 128 L 241.292 128 Z",
    style: {},
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.4cb64236.svg";
export { ForwardRef as ReactComponent };